import * as types from "./actionTypes";

export function evaluateStats(guesseslength, input, guessdigit) {
  return { type: types.EVALUATE_STATS, guesseslength, input, guessdigit };
}
